import React from "react";
import styles from "./Pagination.module.scss";

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  totalCount = 0,
  limit = 5,
  onPageChange,
}) => {
  const start = totalCount === 0 ? 0 : (currentPage - 1) * limit + 1;
  const end = totalCount === 0 ? 0 : Math.min(currentPage * limit, totalCount);

  const handlePrev = () => {
    if (currentPage > 1 && typeof onPageChange === "function") {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages && typeof onPageChange === "function") {
      onPageChange(currentPage + 1);
    }
  };

  // ============================
  // ⭐ NEW SMART PAGINATION LOGIC
  // ============================
  const getPageNumbers = () => {
    let pages = [];

    const showLeftDots = currentPage > 3;
    const showRightDots = currentPage < totalPages - 2;

    // Always include first page
    pages.push(1);

    if (showLeftDots) {
      pages.push("left-dots");
    }

    // Middle pages (current - 1, current, current + 1)
    for (let p = currentPage - 1; p <= currentPage + 1; p++) {
      if (p > 1 && p < totalPages) pages.push(p);
    }

    // Right dots
    if (showRightDots) {
      pages.push("right-dots");
    }

    // Always include last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className={styles.wrapper}>
      <p className={styles.entriesText}>
        {`Showing ${start} to ${end} of ${totalCount} entries`}
      </p>

      <div className={styles.controls}>
        <button
          className={styles.navBtn}
          disabled={currentPage === 1}
          onClick={handlePrev}
        >
          Previous
        </button>

        {/* Render Smart Pagination */}
        {getPageNumbers().map((page, index) => {
          if (page === "left-dots" || page === "right-dots") {
            return (
              <span key={index} className={styles.dots}>
                ...
              </span>
            );
          }

          return (
            <button
              key={index}
              onClick={() => onPageChange(page)}
              className={`${styles.pageNumberBtn} ${
                currentPage === page ? styles.active : ""
              }`}
            >
              {page}
            </button>
          );
        })}

        <button
          className={styles.navBtn}
          disabled={currentPage === totalPages}
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
